'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isDurationTick = require('./isDurationTick');

var _isDurationTick2 = _interopRequireDefault(_isDurationTick);

var _durationToSecs = require('./durationToSecs');

var _durationToSecs2 = _interopRequireDefault(_durationToSecs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (duration, durationUnit) {
    return (0, _isDurationTick2.default)(durationUnit) || (0, _durationToSecs2.default)(duration, durationUnit) < 120;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/duration/isDurationLessThan2Mins.js
// module id = 91
// module chunks = 0